import { useToken } from '@/context/useToken';
import LoginRequired from '@/components/common/LoginRequired';
import Page from '@/components/layout/Page';

import Settings from './Settings';

const SettingsLoader = () => {
  const { token } = useToken();

  if (!token) {
    return (
      <Page>
        <div className="flex justify-center items-center h-screen">
          <div className="text-center">
            <LoginRequired
              title="Settings"
              message="Log in to view your settings."
            />
          </div>
        </div>
      </Page>
    );
  }

  return <Settings />;
};

export default SettingsLoader;
